export const pageVariables = {
    // API Endpoints
    getListas: process.env.VUE_APP_API_URL + "fichas-visita/todas",
    getLista: process.env.VUE_APP_API_URL + "listas",
    getFichaCompleta: process.env.VUE_APP_API_URL + "fichas-visita",
    updateLista: process.env.VUE_APP_API_URL + "listas",
    consultoresPage: process.env.VUE_APP_API_URL + "get-group-members/consultores",

    // Configurações do Título e Textos
    titulo: 'Todas as Visitas (Coordenador)',
    subtitulo: 'Acompanhe e gerencie as fichas de visita de todos os consultores',
    textobotaocreate: 'Nova Visita',
    tituloModalCreate: 'Agendar Nova Visita',
    tituloModalEdit: 'Editar Visita',
    
    // Header da Tabela
    header: [
        { key: 'segurado', label: 'Segurado' },
        { key: 'data_agendamento', label: 'Data de Agendamento' },
        { key: 'data_visita', label: 'Data da Visita' },
        { key: 'consultor_email', label: 'Consultor' },
        { key: 'status_visita', label: 'Status da Visita' },
    ]
};
